// App.jsx
import React from "react";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import UsersList from "./pages/User/users";
import UserForm from "./pages/User/userform";
import Login from "./pages/Login";
import AgentsList from "./pages/Agent/AgentsList";
import AgentForm from "./pages/Agent/AgentForm";
import MainLayout from "./layouts/MainLayout";
import MinimalLayout from "./layouts/MinimalLayout";
import HotelsList from "./pages/Hotel/HotelsList";
import HotelForm from "./pages/Hotel/HotelForm";
import BookingsList from "./pages/Booking/BookingsList";
import BookingForm from "./pages/Booking/BookingForm";
import BillingsList from "./pages/Billing/BillingsList";
import BillingForm from "./pages/Billing/BillingForm";

import RoomCategoryList from "./pages/RoomCategory/RoomCategoryList";
import RoomCategoryForm from "./pages/RoomCategory/RoomCategoryForm";
import PrivateRoute from "./components/PrivateRoute"; 
import ProfileForm from "pages/Profile/profileform";
import CityForm from "pages/City/CityForm";
import CityList from "pages/City/CityList";
import RoomTypeList from "pages/RoomType/RoomTypeList";
import RoomTypeForm from "pages/RoomType/RoomTypeForm";

const App = () => {
  return (
    <>
      <Routes>
        <Route element={<MinimalLayout />}>
          <Route path="" element={<Login />} />
          <Route path="/login" element={<Login />} />
        </Route>

        <Route element={<PrivateRoute />}>
        <Route element={<MainLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/users" element={<UsersList />} />
          <Route path="/add-user" element={<UserForm />} />
          <Route path="/agents" element={<AgentsList />} />
          <Route path="/add-agent" element={<AgentForm />} />
          <Route path="/hotels" element={<HotelsList />} />
          <Route path="/add-hotel" element={<HotelForm />} />
          <Route path="/bookings" element={<BookingsList />} />
          <Route path="/add-booking" element={<BookingForm />} />
          <Route path="/billings" element={<BillingsList />} />
          <Route path="/add-billing" element={<BillingForm />} />
          <Route path="/add-room-category" element={<RoomCategoryForm />} />
          <Route path="/room-categories" element={<RoomCategoryList />} />
          <Route path="/profile" element={<ProfileForm />} />
          <Route path="/add-city" element={<CityForm />} />
          <Route path="/cities" element={<CityList />} />
          <Route path="/add-room-type" element={<RoomTypeForm />} />
          <Route path="/room-types" element={<RoomTypeList  />} />
        </Route>
        </Route>
        <Route path="*" element={<Navigate to="/login" replace />} />

      </Routes>
    </>
  );
};
export default App;
